import { render, staticRenderFns } from "./main_menu.vue?vue&type=template&id=18d47409&scoped=true&"
import script from "./main_menu.vue?vue&type=script&lang=js&"
export * from "./main_menu.vue?vue&type=script&lang=js&"
import style0 from "./main_menu.vue?vue&type=style&index=0&id=18d47409&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d47409",
  null
  
)

export default component.exports